(() => {
  // A section can load this asset again in the Theme Editor.
  const key = Symbol.for('gim.articlePreferredSourceCta');
  if (window[key]) {
    window[key](document);
    return;
  }

  const processed = new WeakSet();
  const ignoredTags = new Set(['SCRIPT', 'STYLE', 'TEMPLATE', 'NOSCRIPT']);
  const safeBlocks = new Set(['P', 'DIV', 'SECTION', 'BLOCKQUOTE', 'UL', 'OL', 'FIGURE', 'TABLE']);
  const isHeading = (element) => /^H[1-6]$/.test(element.tagName);

  function position(cta) {
    if (processed.has(cta)) return;
    const content = cta.parentElement;
    if (!content?.matches('.article-template__content')) return;
    processed.add(cta);

    const children = Array.from(content.children);
    const blocks = children.slice(0, children.indexOf(cta)).filter((element) =>
      !ignoredTags.has(element.tagName) && !element.hidden
    );
    const lengths = blocks.map((element) => element.textContent.trim().length);
    const total = lengths.reduce((sum, length) => sum + length, 0);
    if (!total || blocks.length < 2) return;

    const candidates = [];
    let consumed = 0;
    blocks.forEach((block, index) => {
      consumed += lengths[index];
      const next = blocks[index + 1];
      // Never split a block, put the CTA before all text, or separate a heading
      // from its following content. A single enclosing wrapper stays intact.
      if (!next || consumed === 0 || consumed === total || isHeading(block)) return;
      const headingBoundary = next.tagName === 'H2' || next.tagName === 'H3';
      if (!safeBlocks.has(block.tagName) && !headingBoundary) return;
      const fraction = consumed / total;
      candidates.push({ next, fraction, headingBoundary });
    });

    const nearHeadings = candidates.filter(({ fraction, headingBoundary }) =>
      headingBoundary && fraction >= 0.25 && fraction <= 0.35
    );
    const choices = nearHeadings.length ? nearHeadings : candidates;
    choices.sort((a, b) => Math.abs(a.fraction - 0.3) - Math.abs(b.fraction - 0.3));
    if (choices.length) content.insertBefore(cta, choices[0].next);
    // No safe internal boundary: preserve the server-rendered end placement.
  }

  function initialize(root) {
    root.querySelectorAll('.article-template__content > .article-preferred-source-cta[data-preferred-source-cta]')
      .forEach(position);
  }

  window[key] = initialize;
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }
})();
